export default function Footer() {
    return (
      <>
  
        <footer className="flex justify-center items-center p-4 bg-white border-t-2 border-slate-900/10 overflow-y-hidden">
            <div className="flex-col-reverse sm:flex-row flex w-full">
                <div className="flex w-full h-full justify-center sm:justify-between sm:items-left items-center">
                    <p href="https://www.endevre.com" className="text-sm sm:text-md text-neutral-400 tracking-tight ">
                        © 2023 Endevre Technologies LLC
                    </p>
                </div>
                <div className="flex w-full h-full items-center justify-center sm:items-right text-right sm:justify-end sm:mb-0 mb-1">
                    <div className="flex h-full items-right text-right justify-end">
                        <a href="/docs" className="text-sm sm:text-md text-neutral-400 tracking-tight ml-2 mr-2 sm:ml-5 sm:mr-0">
                            Docs
                        </a>
                    </div>
                    <div className="flex h-full items-right text-right justify-end">
                        <a href="/pricing" className="text-sm sm:text-md text-neutral-400 tracking-tight ml-2 mr-2 sm:ml-5 sm:mr-0">
                            Pricing
                        </a>
                    </div>
                    <div className="flex h-full items-right text-right justify-end">
                        <a href="/legal/privacy" className="text-sm sm:text-md text-neutral-400 tracking-tight ml-2 mr-2 sm:ml-5 sm:mr-0">
                            Privacy
                        </a>
                    </div>
                    <div className="flex h-full items-right text-right justify-end">
                        <a href="/legal/tos" className="text-sm sm:text-md text-neutral-400 tracking-tight ml-2 mr-2 sm:ml-5 sm:mr-0">
                            Terms
                        </a>
                    </div>
                </div>
            </div>
          
        </footer>
      </>
    );
  }
  